var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-nav-tips comp",class:_vm.data.cla},[_c('div',{staticClass:"bg-tit-text"},[_c('span',[_vm._v(_vm._s(_vm.data.tit))]),_c('p',[_vm._v(_vm._s(_vm.data.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }